import React from 'react';
import { Box } from '../../../../base/Box/Box';
import { InsightsGridCardStoryblok } from '../../../../types/storyblok';
import { StoryblokImage } from '../../../../base/StoryblokImage/StoryblokImage';

export const InsightsGridCard = ({
  image,
  heading,
}: InsightsGridCardStoryblok) => {
  if (!image && !heading) {
    return null;
  }

  return (
    <Box as="section">
      <StoryblokImage src={image} alt="" mode="responsive" maxWidth={600} />
    </Box>
  );
};

export default InsightsGridCard;
